import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getInitialLang, persistLangSideEffects, getDict } from "../utils/i18n";

const LangContext = createContext({ lang: "tr", setLang: () => {}, dict: getDict("tr") });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    persistLangSideEffects(lang);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, dict: getDict(lang) }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}